import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import 'magnific-popup';
import '../../shared/_magnificPopup.scss'

import Bullet from "./Bullet/Bullet";
import Buttons from "./Buttons/Buttons";
import SpiderClass from "../Spider/SpiderClass";
import ResultSet from "../../libs/ResultSet";
import Socials from "../Socials/Socials";

import data from "./results.json";

import "./Results.scss";



const Results = (props) => {
  const CURR_QUESTIONS = props.currentQuestions;
  const specificScore = props.specificScore;
  const currLang = props.currentLang;

  const [rslTitle, setrslTitle] = useState(0);

  const resultTitle = (scoress) => {
    const numOfPerfScore = scoress.reduce(
      (a, v) => (Number(v) === 100 ? a + 1 : a),
      0
    );

    if (numOfPerfScore >= 4) {
      return ResultSet.titleB[currLang];
    } else if (numOfPerfScore < 4) {
      return ResultSet.titleM[currLang];
    } else {
      return ResultSet.titleB[currLang];
    }
  };


  useEffect(() => {
    setrslTitle(resultTitle(props.specificScore));


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.specificScore]);

  useEffect(() => {
    for (let question of CURR_QUESTIONS) {
      const { negCopy, negLink, negLinkText } = question;

      question.currNegCopy = negCopy[currLang];
      question.currNegLink = negLink[currLang];
      question.currNegLinkText = negLinkText[currLang];
    }
  }, [currLang, CURR_QUESTIONS]);

  const bullets = specificScore.map((score, i) => {
    return (
      <Bullet
        linkID={`bullet${i}`}
        title={CURR_QUESTIONS[i].currH}
        mainN={CURR_QUESTIONS[i].currNegCopy}
        subNLink={CURR_QUESTIONS[i].currNegLink}
        subNLinkText={CURR_QUESTIONS[i].currNegLinkText}
        key={`bullet${i}`}
        score={score}
      />
    );
  });


  return (
    <React.Fragment>
      <div className="Results__spider--wrapper">
        <div className="Results__subtitle Results__subtitle--1">
          {data.subtitle[currLang]}
        </div>
        <div className="Results__group Results__group--1">
          <div className="Results__title Results__title--1">
            {data.title[currLang]}
          </div>
          <div className="Results__legend--group Results__legend--group--1"  aria-hidden="true">
            <div className="Results__legend Results__legend--1">
              <div className="Results__legend--icon Results__legend--icon-1"></div>
              <div className="Results__legend--text Results__legend--text-1"></div>
            </div>
            <div className="Results__legend Results__legend--2">
              <div className="Results__legend--icon Results__legend--icon-2"></div>
              <div className="Results__legend--text Results__legend--text-2">
                On track
              </div>
            </div>
          </div>
        </div>

        <SpiderClass isMob={true} />
        <Buttons />
      </div>
      <h2 className="Results__subtitle Results__subtitle--2" tabIndex='-1'>
        {" "}
        {data.subtitle[currLang]}
      </h2>
      <div className="Results__group Results__group--2">
        <div className="Results__title Results__title--2">
          {data.title[currLang]}
        </div>
        <div className="Results__legend--group" aria-hidden="true" >
          <div className="Results__legend Results__legend--1">
            <div className="Results__legend--icon Results__legend--icon-1"></div>
            <div className="Results__legend--text Results__legend--text-1">
              {data.key1[currLang]}
            </div>
          </div>
          <div className="Results__legend Results__legend--2">
            <div className="Results__legend--icon Results__legend--icon-2"></div>
            <div className="Results__legend--text Results__legend--text-2">
              {data.key2[currLang]}
            </div>
          </div>
        </div>
      </div>
      <div className="Results__hr"></div>
      <ul className="Results__points">
        {bullets}
        <Buttons />
        <Socials shareText={data.share[currLang]} />
      </ul>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currentQuestions: state.questionsReducer.currentQuestions,
    specificScore: state.scoreReducer.specificScore,

    currentLang: state.langReducer.currentLang,
    currentRole: state.roleReducer.currentRole,
    currentTxtRole: state.roleReducer.currentTxtRole,
  };
};

export default connect(mapStateToProps, null)(Results);
